export enum MagicRendererProperties {
  // Switch labels
  LABEL_TRUE = "label.true",
  LABEL_FALSE = "label.false",
  // Table operation buttons
  BUTTON_TYPE = "button.type",
  BUTTON_ICON_CSS = "button.icon.css",
  // Related list buttons
  ENABLE_CREATE_BUTTON = "enableCreateButton",
  ENABLE_QUICK_ENTRY_BUTTON = "enableQuickEntryButton",
  // Related list sorting
  RELATED_LIST_SORT_ORDER = "sortOrder",
  // Related list column list
  RELATED_LIST_COLUMNS = "columnList",
  // Related list query
  RELATED_LIST_QUERY = "listQuery",
  // Accounting currency
  ACCOUNTING_CURRENCY = "accounting.currency", // string representation, e.g. ₹
  ACCOUNTING_CURRENCY_NAME = "accounting.currency.name", // e.g. rupee, used for CSS, matches class accounting-currency-rupee
  ACCOUNTING_CURRENCY_FONT_SIZE = "accounting.currency.font.size", // e.g. 12px, used for CSS
  ACCOUNTING_CURRENCY_CODE = "accounting.currency.code", // e.g. INR
  NUMBER_FORMAT_FRACTION_DIGITS = "number.format.fraction.digits", // e.g. 2
  // Money currency
  MONEY_CURRENCY_SYMBOL = "money.currency.symbol", // any truthy value will trigger symbol display like € for matching MONEY_CURRENCY_CODE ie EUR
  MONEY_CURRENCY_CODE = "money.currency.code", // e.g. INR
}
